import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=71fbc737&scoped=true&"
import script from "./AddAsset.vue?vue&type=script&lang=ts&"
export * from "./AddAsset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fbc737",
  null
  
)

export default component.exports